import React from 'react';

import * as styles from './Select.module.scss';

interface props {
    children: React.ReactNode,
    [key: string]: any
}

const Select = ({ children, ...rest }: props): JSX.Element => { // eslint-disable-line object-curly-newline
    return (
        <select className={`note ${styles.Select}`} {...rest}>
            {children}
        </select>
    );
};

export default Select;
